module.exports = __webpack_public_path__ + "img/stena05.9b75bf7c.jpg";